import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form//cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class PaymentTermForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.getView());
  }
  
  private getView(): CerFormView {
    const view = new CerFormView();
    view.viewMetadata = {
      name: 'payment-term', dataApiName: 'PaymentTerm', text: 'Betalingsbetingelser', textSingular: 'Betalingsbetingelse',
      primaryKey: 'num', titleFields: ['num', 'name'], baseFields: ['id', 'num', 'name'],
      allowCreate: false, allowEdit: false, allowDelete: false
    };
    return view;
  }
}
